import { render, staticRenderFns } from "./WelcomeMsgPopup.vue?vue&type=template&id=31b08bb8&scoped=true"
import script from "./WelcomeMsgPopup.vue?vue&type=script&lang=ts"
export * from "./WelcomeMsgPopup.vue?vue&type=script&lang=ts"
import style0 from "./WelcomeMsgPopup.vue?vue&type=style&index=0&id=31b08bb8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b08bb8",
  null
  
)

export default component.exports